import { onMounted, ref, reactive } from 'vue';
import BannerSwiper from '@/components/BannerSwiper/index.vue';
import Content from '@/pages/ecoPartner/content/content.vue';
export default {
  components: {
    BannerSwiper: BannerSwiper,
    Content: Content
  },
  name: 'Index',
  setup: function setup() {
    var bannerList = reactive([{
      id: 0,
      // new_banner_eco_02
      // imageUrl: 'https://cdn.tenacia.com/base/tenacia-img/new_banner_eco_03.png',
      imageUrl: require('./image/1-3.png')
    }]);
    return {
      bannerList: bannerList
    };
  }
};